import { render, staticRenderFns } from "./ZaloConversationList.vue?vue&type=template&id=98cd7cd4"
import script from "./ZaloConversationList.vue?vue&type=script&lang=js"
export * from "./ZaloConversationList.vue?vue&type=script&lang=js"
import style0 from "./ZaloConversationList.vue?vue&type=style&index=0&id=98cd7cd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports